import { render } from "./ReabonnementsListPage.vue?vue&type=template&id=26882de9&ts=true"
import script from "./ReabonnementsListPage.vue?vue&type=script&lang=ts"
export * from "./ReabonnementsListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__